import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@/assets/icons/delete-icon.svg?react';
import { CustomButton } from '@/components/global/buttons/CustomButton.jsx';
import { retailChainSectionStyles } from '@/themes/commonStyles/retailChainForm.js';

const StyledSection = styled(Box)(retailChainSectionStyles);

export const RetailChainPendingBrands = ({ brands, onAdd, onRemove }) => {
    const translate = useTranslate();

    return (
        <StyledSection>
            <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={2}>
                <Typography variant='h5'>{translate('resources.retailChain.fields.brands')}</Typography>
                <CustomButton type='button' color='primary' variant='contained' label='resources.brand.labels.create' onClick={onAdd} />
            </Stack>
            {brands.length > 0 ? (
                <Stack spacing={3}>
                    {brands.map(brand => (
                        <Stack key={brand.clientId} direction='row' alignItems='center' justifyContent='space-between' spacing={1}>
                            <Typography variant='body2'>{brand.name}</Typography>
                            <IconButton
                                type='button'
                                onClick={() => onRemove(brand.clientId)}
                                aria-label={translate('common.remove')}
                                title={translate('common.remove')}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    ))}
                </Stack>
            ) : null}
        </StyledSection>
    );
};

RetailChainPendingBrands.propTypes = {
    brands: PropTypes.arrayOf(
        PropTypes.shape({
            clientId: PropTypes.string.isRequired,
            name: PropTypes.string,
        }),
    ).isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
};
